import Button from "@atlaskit/button";
import styled from "styled-components";
import React, { useContext } from "react";
import EditorAddIcon from "@atlaskit/icon/glyph/editor/add";
import { events } from "@forge/bridge";
import { useTranslation } from "react-i18next";
import { BannerContext } from "../../../context";

const ButtonWrapper = styled.div`
  flex-shrink: 0;

  ${({ buttonType }) => {
    if (buttonType === "custom") {
      return `
        svg {
            color: #172b4d !important;
        }
        button > span {
            color: #172b4d !important;
        }
      `;
    }
    return "";
  }}
`;

function AddItemsButton({ buttonType }) {
  const { t } = useTranslation();
  const { isOnJSM, config: { buttonText } = {} } = useContext(BannerContext);

  const buttonStyles =
    buttonType === "custom" ? { backgroundColor: "#fff" } : {};

  return (
    <ButtonWrapper buttonType={buttonType}>
      <Button
        style={{ ...buttonStyles }}
        iconBefore={<EditorAddIcon />}
        appearance="primary"
        onClick={() => {
          if (!isOnJSM) return;
          events.emit("OPEN_CATALOG_BROWSER");
        }}
      >
        {buttonText || t("add-items")}
      </Button>
    </ButtonWrapper>
  );
}

export default AddItemsButton;
